import { InvoiceStatus } from '@/types/checkout';

export enum ErrorType {
  INVOICE_NOT_FOUND = 'INVOICE_NOT_FOUND',
  FAILED_TO_PAYMENT = 'FAILED_TO_PAYMENT',
  BAD_REQUEST = 'BAD_REQUEST',
  PAID = 'PAID',
  DISABLED = 'DISABLED',
  EXPIRED = 'EXPIRED',
  DEFAULT = 'Oops! Something went wrong',
}

export const ErrorMapping = {
  [ErrorType.INVOICE_NOT_FOUND]: { error: ErrorType.INVOICE_NOT_FOUND, message: ErrorType.INVOICE_NOT_FOUND },
  [ErrorType.FAILED_TO_PAYMENT]: { error: ErrorType.FAILED_TO_PAYMENT, message: ErrorType.FAILED_TO_PAYMENT },
  [ErrorType.BAD_REQUEST]: { error: ErrorType.BAD_REQUEST, message: ErrorType.BAD_REQUEST },
  [InvoiceStatus.INVALID]: { error: InvoiceStatus.INVALID, message: InvoiceStatus.INVALID },
  [InvoiceStatus.PAID]: { error: InvoiceStatus.PAID, message: InvoiceStatus.PAID },
  [ErrorType.DEFAULT]: { error: ErrorType.DEFAULT, message: ErrorType.DEFAULT },
  [ErrorType.PAID]: { error: ErrorType.PAID, message: ErrorType.PAID },
  [ErrorType.DISABLED]: { error: ErrorType.DISABLED, message: ErrorType.DISABLED },
  [ErrorType.EXPIRED]: { error: ErrorType.EXPIRED, message: ErrorType.EXPIRED },
};

export type CheckoutError = {
  error: ErrorType | InvoiceStatus;
  message: string;
  logoUrl?: string;
};

export type ErrorCodeTypes =
  | 'CODE_BAD_SYMBOLS'
  | 'CODE_NOT_FOUND'
  | 'CODE_NOT_UNIQUE'
  | 'DESC_TOO_LONG'
  | 'REF_EMTPY'
  | 'REUSABLE_EMTPY'
  | 'AMOUNT_EMTPY'
  | 'BAD_EXPIRY'
  | 'INTENT_CREATED'
  | 'LINK_FORBIDDEN'
  | 'LINK_NOT_FOUND'
  | 'LINK_NOT_ACTIVE'
  | 'CONFIG_NOT_FOUND'
  | 'CORE_FAILED'
  | 'AMOUNT_WRONG'
  | 'HEADER_MISSING'
  | 'ARGUMENT_MISMATCH'
  | 'OTHER_ERROR'
  | 'INTENT_NOT_PAID';

export type PBLError = {
  code?: number;
  type?: ErrorCodeTypes;
  message: string;
};
